import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MarketplaceRoutingModule } from './marketplace-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MarketplacePage } from './marketplace.page';
import { MarketplaceDetailsComponent } from './marketplace-details/marketplace-details.component';
// import { RemoveSpecialCharactersFromStringPipe } from '../core/pipes/remove-special-characters-from-string.pipe';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MarketplaceFilterComponent } from './marketplace-filter/marketplace-filter.component';
import { MarketplacePaginationComponent } from './marketplace-pagination/marketplace-pagination.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatSidenavModule } from '@angular/material/sidenav';
// import { RemoveSpecialCharactersFromStringPipe } from '../core/pipes/remove-special-characters-from-string.pipe';-
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MarketplaceCartComponent } from './marketplace-cart/marketplace-cart.component';


@NgModule({
  declarations: [
    MarketplacePage,
    MarketplaceDetailsComponent,
    MarketplaceCartComponent,
    MarketplaceFilterComponent,
    MarketplacePaginationComponent
    // RemoveSpecialCharactersFromStringPipe
  ],
  imports: [
    CommonModule,
    MarketplaceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedModule,
    MatChipsModule,
    MatIconModule,
    MatBottomSheetModule,
    MatSidenavModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MarketplaceModule { }
